var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUparrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 200,
    viewBox: "0 0 250 300",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M345.34 257.321L186.245 7.32166C183.263 2.63333 179.215 0 174.996 0C170.776 0 166.73 2.63499 163.746 7.32332L4.65977 257.323C-1.55326 267.086 -1.55326 282.915 4.65977 292.678C10.8717 302.44 20.9454 302.441 27.1584 292.678L174.996 60.3566L322.841 292.678C325.948 297.56 330.02 300 334.091 300C338.163 300 342.235 297.56 345.341 292.676C351.553 282.913 351.553 267.085 345.34 257.321Z",
    fill: "#00ACC1",
    stroke: "#00ACC1",
    strokeWidth: 30
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUparrow);
export default __webpack_public_path__ + "static/media/uparrow.879ceff0470c752ef8a56dabb36aa15d.svg";
export { ForwardRef as ReactComponent };